module.exports = __webpack_public_path__ + "18a4e7094129478b5638f6fe90ef6b46.MP3";